// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__19k68","itemTitle":"ClientEmergencyInfo_itemTitle__3m1ny","itemText":"ClientEmergencyInfo_itemText__3GjQu"};